import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = ({ onGetStarted }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background - Colorful CBS style gradient with video overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          background: 'linear-gradient(135deg, rgba(196, 30, 58, 0.92) 0%, rgba(231, 76, 60, 0.88) 25%, rgba(212, 175, 55, 0.8) 50%, rgba(192, 192, 192, 0.85) 75%, rgba(196, 30, 58, 0.92) 100%)'
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover opacity-20"
          style={{ mixBlendMode: 'overlay' }}
        >
          <source src="https://customer-assets.emergentagent.com/job_1cbf181c-f588-4bee-a281-c5df8c1cd653/artifacts/bejar1he_Silver%20dollar%20logo%20%281%29.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">

        {/* Done-For-You */}
        <h1 className="mb-4" style={{ fontSize: '1.5rem', fontWeight: '700', color: '#2D2D2D' }}>
          Done-For-You AI Services
        </h1>

        {/* Creamy tagline */}
        <p className="mb-8" style={{ fontSize: '1.2rem', fontWeight: '500', color: '#FFE4B5', fontStyle: 'italic' }}>
          Drop off your AI worries. We service wash them while you live your life.
        </p>

        {/* Silver Dollar Logo with Gold Border Frame */}
        <div className="mb-8">
          <div 
            style={{
              display: 'inline-block',
              padding: '2px',
              background: '#D4AF37',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
            }}
          >
            <div
              style={{
                borderRadius: '8px',
                overflow: 'hidden',
                border: '2px solid #8B0000'
              }}
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: '320px',
                  height: 'auto',
                  display: 'block'
                }}
              >
                <source src="https://customer-assets.emergentagent.com/job_1cbf181c-f588-4bee-a281-c5df8c1cd653/artifacts/m38cf5um_Silver%20dollar%20logo.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
        
        <p className="body-large mb-8" style={{ maxWidth: '700px', margin: '0 auto 2rem', color: '#2D2D2D', fontWeight: '700' }}>
          Zero learning curve. Simple 50/50 payment. Total peace of mind.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              } else {
                if (onGetStarted) {
                  onGetStarted();
                } else {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
              }
            }}
            className="btn-primary hover-scale"
            style={{ minWidth: '180px', background: '#2D2D2D' }}
          >
            <span className="flex items-center gap-2">
              Get Started
              <ArrowRight size={18} />
            </span>
          </Button>
          <Button 
            onClick={() => {
              const servicesSection = document.getElementById('services');
              if (servicesSection) {
                servicesSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="btn-secondary hover-scale"
            style={{ minWidth: '180px', background: 'rgba(255, 255, 255, 0.9)', color: '#2D2D2D', border: '2px solid #D4AF37' }}
          >
            Learn More
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;